export default __webpack_public_path__ + "static/media/discover_match_mockup.e75e14b1.png";